import styled from 'styled-components';
import { mediaQueryMobileLargeMin } from 'styleUtils';
export var AllFiltersWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-15lwrxj-0"
})(["width:100%;"]);
export var MainFilterWrapper = /*#__PURE__*/styled.form.withConfig({
  componentId: "sc-15lwrxj-1"
})(["display:flex;flex-flow:row wrap;width:100%;@media ", "{display:flex;margin:0;padding:0;width:100%;align-items:center;justify-content:center;flex-flow:row nowrap;}"], mediaQueryMobileLargeMin);